import { WidgetStore } from "../types";

// UI Selectors
export const selectButtonState = (state: WidgetStore) => state.buttonState;
export const selectIsRecording = (state: WidgetStore) => state.isRecording;
export const selectIsAgentSpeaking = (state: WidgetStore) =>
  state.isAgentSpeaking;
export const selectIsAgentThinking = (state: WidgetStore) =>
  state.isAgentThinking;
export const selectIsWidgetActive = (state: WidgetStore) =>
  state.isWidgetActive;
export const selectIsWidgetDisabled = (state: WidgetStore) =>
  state.isWidgetDisabled;

// Connection Selectors
export const selectConnectionStatus = (state: WidgetStore) =>
  state.connectionStatus;
export const selectConversationId = (state: WidgetStore) =>
  state.conversationId;
export const selectBackendSessionId = (state: WidgetStore) =>
  state.backendSessionId;
export const selectIsConnected = (state: WidgetStore) =>
  state.connectionStatus === "connected";

// Conversation Selectors
export const selectMessages = (state: WidgetStore) => state.messages;
export const selectTranscript = (state: WidgetStore) => state.transcript;
export const selectConversationItems = (state: WidgetStore) =>
  state.conversationItems;
export const selectSortedConversationItems = (state: WidgetStore) =>
  [...state.conversationItems].sort((a, b) => a.timestamp - b.timestamp);

// Quota Selectors
export const selectHasQuota = (state: WidgetStore) => state.hasQuota;
export const selectQuotaCheckComplete = (state: WidgetStore) =>
  state.quotaCheckComplete;
export const selectRemainingMinutes = (state: WidgetStore) =>
  state.remainingMinutes;

// Config Selectors
export const selectWidgetName = (state: WidgetStore) => state.widgetName;
export const selectWelcomeMessage = (state: WidgetStore) =>
  state.welcomeMessage;

// Error Selectors
export const selectError = (state: WidgetStore) => state.error;
export const selectHasError = (state: WidgetStore) => state.error !== null;
